import { LiteBox } from "apps/platform-client/client/src/components/lite/LiteBox";
import { Loading } from "@lyfegen-platform/react-common";
import useOrganizationStyles from "../use-organization-styles";
import { DomainCard } from "./components/DomainCard";
import { GET_ORGANIZATION_DOMAINS_WITH_COUNTERS } from "../queries";
import { GetOrganizationDomainsWithCountersQuery } from "../types/queries.generated";
import { SIMULATION_SUBSCRIPTION } from "../../../data/queries";
import { useModelsQuery } from "apps/platform-client/client/src/hooks/useModelsModule";
import SubscriptionForModelsUpdates from "apps/platform-client/client/src/hooks/subscription-for-models-updates";
import { globalDomainId } from "@lyfegen-platform/graphql-schema/models";

export const DomainsTab = () => {
	const { organizationActionSettingsContainer } = useOrganizationStyles();
	const { data, loading, refetch } = useModelsQuery<GetOrganizationDomainsWithCountersQuery>(GET_ORGANIZATION_DOMAINS_WITH_COUNTERS, {
		fetchPolicy: "no-cache",
	});
	const userDomains = data?.GetOrganizationDomainsWithCounters.domains;
	const firstAvailableDomain = userDomains?.[0];
	const globalDomain = firstAvailableDomain?.id === globalDomainId ? firstAvailableDomain : undefined;

	return (
		<>
			<SubscriptionForModelsUpdates onCompleted={refetch} query={SIMULATION_SUBSCRIPTION} />
			{userDomains?.length && (
				<LiteBox hidden={loading} className={organizationActionSettingsContainer}>
					<DomainCard userDomains={userDomains} globalDomain={globalDomain} />
				</LiteBox>
			)}
			{loading && (
				<LiteBox width="100%" height="100%" justifyContent="center" alignItems="center" display="flex" padding="20vh">
					<Loading />
				</LiteBox>
			)}
		</>
	);
};
